import React, { useState } from "react";
import styles from "../../styles/chat.module.scss";
import { Divider, Image, Modal } from "antd-mobile";
import { useTheme } from "../../context/ThemeContext";
export default function ChatHeader(props: { onCreat: () => void }) {
  const { theme, toggleTheme } = useTheme();
  const [visible, setVisible] = useState(false);
  const handleList = () => {
    setVisible(true);
  };
  return (
    <div className={styles.chatHeader}>
      <div className={styles.chatHeaderBox}>
        <img
          src={theme === 'dark'?"chat/list.png":"chat/list_light.png"}
          alt="对话列表"
          onClick={handleList}
          className={styles.icon}
        ></img>
        <div className={styles.title}>Eagle <span>DevAgent</span></div>
        <img
          src={theme === 'dark'?"chat/creat.png":"chat/creat_light.png"}
          alt="新建对话"
          onClick={props.onCreat}
          className={styles.icon}
        ></img>
      </div>
      <Modal
        visible={visible}
        bodyClassName={styles.darkModal}
        content={
          <div className={styles.headMoadl}>
            <div className={styles.text}>
              请使用电脑端登录Eagle， <br /> 体验历史对话记录、 <br />仓库目录树等完整功能
            </div>
          </div>
        }
        closeOnAction
        onClose={() => {
          setVisible(false);
        }}
        actions={[
          {
            key: "confirm",
            style: { color: "var(--primary-text-color)" },
            text: "确认",
          },
        ]}
      ></Modal>
    </div>
  );
}
